module.exports = __webpack_public_path__ + "static/media/casi_lo_logras_1.a7796b74.png";